/* detect IE and display message */
var isIE = /MSIE|Trident/.test(window.navigator.userAgent);
if (isIE) {
    document.getElementById('msie').style.display = 'block';
}
